import { Card } from "antd";
import { useState, useEffect } from "react";
import HTTPClient from "../../../utils/HTTPClient";
import Console from "react-console-emulator";

const Logs = ({ appName, app }) => {
    const [logs, setLogs] = useState([]);
    const fetchLogs = () => {
        HTTPClient.get(`/appcustomizations/logs/${appName}/${app?.technology}`)
            .then((res) => {
                const response_logs = res.data.split("\n");
                setLogs(response_logs);
            })
            .catch((e) => {
                setLogs("");
            });
    };

    useEffect(() => {
        fetchLogs()
    }, []);

    useEffect(() => {
        const interval = setInterval(fetchLogs, 5000); // Effettua la chiamata ogni 5 secondi
        return () => clearInterval(interval);
    }, [app?.technology, appName]);

    if (!logs) return null;

    return (
        <Card title="Log" style={{ width: "100%", marginTop: "10px" }}>
            <Console
                autoFocus={false}
                promptLabel={logs.map((log) => (
                    <div> {log}</div>
                ))}
                disabled
                noDefaults
                style={{ maxHeight: "50px" }}></Console>
        </Card>
    );
};

export { Logs };
